import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  name: "HighLighted",
})
class HighLighted extends Vue {
  @Prop({ type: String, default: "" })
  readonly htmlContent!: string;

  render() {
    return (
      <span
        class="highlight cell-data"
        domPropsInnerHTML={this.htmlContent}
      ></span>
    );
  }
}

export default HighLighted;
